/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {
  GetReceiveNoteBasketResponse,
  NormalizedBasketItems,
  NormalizedBasketTotalPrice,
} from './types';

export const normalizeBasketItems = (
  response: GetReceiveNoteBasketResponse
): NormalizedBasketItems => {
  const items: NormalizedBasketItems['items'] = {};
  const itemIds: string[] = [];

  (response?.receiveNoteBasketItem ?? []).forEach((item) => {
    itemIds.push(item.id);
    items[item.id] = item;
  });

  return {itemIds, items};
};

export const normalizeBasketTotalPrice = (
  response: GetReceiveNoteBasketResponse
): NormalizedBasketTotalPrice => ({
  totalPrice: response?.receiveNoteBasketTotalPrice ?? null,
});
